import { render, staticRenderFns } from "./offer-original-price.vue?vue&type=template&id=2c07a4d1&scoped=true"
import script from "./offer-original-price.vue?vue&type=script&lang=js"
export * from "./offer-original-price.vue?vue&type=script&lang=js"
import style0 from "./offer-original-price.vue?vue&type=style&index=0&id=2c07a4d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07a4d1",
  null
  
)

export default component.exports